import { render, staticRenderFns } from "./ProductSelectionCard.vue?vue&type=template&id=f2714c2a&scoped=true"
import script from "./ProductSelectionCard.vue?vue&type=script&lang=js"
export * from "./ProductSelectionCard.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectionCard.vue?vue&type=style&index=0&id=f2714c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2714c2a",
  null
  
)

export default component.exports